import { Component, Input, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { EqBaseComponent } from '../eq-base/eq-base.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
const Material = [
  MatFormFieldModule,
  MatRippleModule,
  MatIconModule,
  MatSelectModule,
];
@Component({
  selector: 'eq-dropdown',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ...Material
  ],
  templateUrl: './dropdown.component.html',
  styleUrl: './dropdown.component.scss',
  encapsulation: ViewEncapsulation.None

})
export class DropdownComponent extends EqBaseComponent {
  @Input() options: any = [
    { label: "Default", value: "default", isDisable: false},
  ]
  @Input() multiSelect: boolean = false;
  clearFilter(event: any){
    event.preventDefault()
    this.form.get(this.name)?.reset();
  }
}
